import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { setup2FAService } from '../../../services/user';
import StepOne from './StepOne';
import StepTwo from './StepTwo';
import StepThree from './StepThree';

import './setup2FA.scss';

const StepProgress = ({ current }) => {
  const labels = ['Escanear', 'Confirmar', 'Listo'];
  return (
    <div className="step-progress">
      {[1, 2, 3].map((n) => (
        <span
          key={n}
          className={`dot${n < current ? ' done' : ''}${n === current ? ' active' : ''}`}
        />
      ))}
      <span className="step-label">
        {`Paso ${current} de 3 · ${labels[current - 1]}`}
      </span>
    </div>
  );
};

StepProgress.propTypes = { current: PropTypes.number.isRequired };

const Setup2FA = ({
  email, password, qr, secret, onSetupComplete,
}) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async (token1, token2) => {
    setLoading(true);
    setError(null);
    try {
      await setup2FAService({
        email, password, secret, token1, token2,
      });
      setStep(3);
    } catch {
      setError('Los códigos no son válidos. Intenta de nuevo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`setup2fa step-number-${step}`}>
      <StepProgress current={step} />
      {step === 1 && (
        <StepOne qr={qr} secret={secret} onNext={() => setStep(2)} />
      )}
      {step === 2 && (
        <StepTwo
          onBack={() => { setError(null); setStep(1); }}
          onConfirm={handleConfirm}
          loading={loading}
          error={error}
        />
      )}
      {step === 3 && (
        <StepThree onFinish={onSetupComplete} />
      )}
    </div>
  );
};

Setup2FA.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  qr: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired,
  onSetupComplete: PropTypes.func.isRequired,
};

export default Setup2FA;
